var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18942_39326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71631 7.19702C10.4584 7.70077 10.9784 8.38327 10.9784 9.29327V10.9183H13.1451V9.29327C13.1451 8.11244 11.2113 7.41369 9.71631 7.19702Z",
    fill: "#64748D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56169 6.58504C6.7583 6.58504 7.72835 5.61499 7.72835 4.41838C7.72835 3.22176 6.7583 2.25171 5.56169 2.25171C4.36507 2.25171 3.39502 3.22176 3.39502 4.41838C3.39502 5.61499 4.36507 6.58504 5.56169 6.58504Z",
    fill: "#64748D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81173 6.58504C10.0088 6.58504 10.9784 5.61546 10.9784 4.41838C10.9784 3.22129 10.0088 2.25171 8.81173 2.25171C8.55714 2.25171 8.31881 2.30588 8.09131 2.38171C8.54089 2.93963 8.81173 3.64921 8.81173 4.41838C8.81173 5.18754 8.54089 5.89713 8.09131 6.45504C8.31881 6.53088 8.55714 6.58504 8.81173 6.58504Z",
    fill: "#64748D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56185 7.12671C4.1156 7.12671 1.22852 7.85254 1.22852 9.29338V10.9184H9.89518V9.29338C9.89518 7.85254 7.0081 7.12671 5.56185 7.12671Z",
    fill: "#64748D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18942_39326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.687012 0.0849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.33a0af163ddc06cb9c76aa1c27fe1f42.svg";
export { ForwardRef as ReactComponent };